import { getLogisticsTenant, logisticsTenant } from '../../application/configuration/login/multiTenantUtils';

type ApplicationTheme = 'rio' | 'scania';

export const getTheme = (): ApplicationTheme => {
    if (import.meta.env.VITE_THEME_OVERRIDE) {
        return import.meta.env.VITE_THEME_OVERRIDE;
    }

    switch (getLogisticsTenant()) {
        case 'scania-cn-sandbox':
        case 'scania-cn-preprod':
        case 'scania-cn':
        case 'scania-cn-dev':
        case 'rio-scm-test':
            return 'scania';
        case 'rio-demo':
            return 'rio';
    }
};

/**
 * Temporary migration helper for existing primary actions. New buttons should choose their style based on their
 * semantic purpose instead of relying on tenant-specific styling.
 */
export const getPrimaryButtonStyle = () =>
    getLogisticsTenant() === logisticsTenant.RIO_DEMO ? 'primary' : 'secondary';

/**
 * Temporary migration helper for legacy native buttons. New buttons should use the UIKIT Button component and
 * choose their style based on their semantic purpose instead of relying on tenant-specific styling.
 */
export const getPrimaryButtonClass = () => `btn-${getPrimaryButtonStyle()}`;
